import { render } from "./DynamicHtmlSmall.vue?vue&type=template&id=71961ff5&ts=true"
import script from "./DynamicHtmlSmall.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlSmall.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71961ff5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71961ff5', __exports__)) {
    api.reload('71961ff5', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlSmall.vue?vue&type=template&id=71961ff5&ts=true", () => {
    api.rerender('71961ff5', render)
  })

}


export default __exports__